
const DEFAULT_AVATAR = 'https://cdn-alioss-bj-open.intab.cn/static/gcloud/2020/assets/images/avatar/male/1.128.png';

export class Account {

    public static translate(rawData) {

        rawData = rawData || {};

        let ret = {
            user_id: rawData.id || 0,
            avatar: rawData.avatar || DEFAULT_AVATAR,
            pos: rawData.pos || '未定义职位',
            realname: rawData.realname || '',
            phone: rawData.phone || '',
            open_id: rawData.open_id || ''
        };

        let idx, poses = [];
        if (rawData.role_list) {
          for (idx = 0; idx < rawData.role_list.length; idx++) {
              poses.push( rawData.role_list[idx].rolename );
          }
          if (poses.length) {
              ret.pos = poses.join(' ');
          }
        }


        return ret;
    }


}
